import React from 'react';

interface ResetInputProps {
    fill?: string;
}

export const ResetInput = ({ fill = '#818998' }: ResetInputProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4595_32547)">
                <g clipPath="url(#clip1_4595_32547)">
                    <path
                        d="M10.6667 5.33289C10.5417 5.20791 10.3722 5.1377 10.1954 5.1377C10.0186 5.1377 9.84907 5.20791 9.72405 5.33289L8.00005 7.05689L6.27605 5.33289C6.15031 5.21145 5.98191 5.14425 5.80711 5.14577C5.63232 5.14729 5.46511 5.2174 5.3415 5.34101C5.2179 5.46461 5.14778 5.63182 5.14627 5.80662C5.14475 5.98142 5.21194 6.14982 5.33338 6.27555L7.05738 7.99955L5.33338 9.72355C5.21194 9.84929 5.14475 10.0177 5.14627 10.1925C5.14778 10.3673 5.2179 10.5345 5.3415 10.6581C5.46511 10.7817 5.63232 10.8518 5.80711 10.8533C5.98191 10.8549 6.15031 10.7877 6.27605 10.6662L8.00005 8.94222L9.72405 10.6662C9.84978 10.7877 10.0182 10.8549 10.193 10.8533C10.3678 10.8518 10.535 10.7817 10.6586 10.6581C10.7822 10.5345 10.8523 10.3673 10.8538 10.1925C10.8554 10.0177 10.7882 9.84929 10.6667 9.72355L8.94271 7.99955L10.6667 6.27555C10.7917 6.15053 10.8619 5.981 10.8619 5.80422C10.8619 5.62744 10.7917 5.4579 10.6667 5.33289Z"
                        fill={fill}
                    />
                    <path
                        d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6649 9.76757 13.962 11.4622 12.7121 12.7121C11.4622 13.962 9.76757 14.6649 8 14.6667Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4595_32547">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_4595_32547">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
